import React from "react";
import { IResourceComponentsProps, useTranslate } from "@refinedev/core";
import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Checkbox, Select } from "antd";
import { IRole, ITeam } from "interfaces";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult, onFinish } = useForm();
  const t = useTranslate();

  const usersData = queryResult?.data?.data;
  const { selectProps: roleSelectProps } = useSelect<IRole>({
    resource: "roles",
    optionLabel: "name",
    optionValue: "id",
  });
  const { selectProps: teamSelectProps } = useSelect<ITeam>({
    resource: "teams",
    optionLabel: "name",
    optionValue: "id",
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout='vertical'
        onFinish={(values: any) => {
          const result = {
            ...values,
            role: values.roleEdit,
            team: values.teamEdit,
          };
          onFinish(result).catch((error) => error);
        }}
      >
        <Form.Item
          label='Id'
          name={["id"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input readOnly disabled />
        </Form.Item>
        <Form.Item
          label='Name'
          name={["name"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Email'
          name={["email"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label='Is Active'
          valuePropName='checked'
          name={["isActive"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Checkbox>Is Active</Checkbox>
        </Form.Item>
        <Form.Item
          label={t("Role")}
          name='roleEdit'
          rules={[
            {
              required: true,
            },
          ]}
          initialValue={usersData?.role?.id}
        >
          <Select
            {...roleSelectProps}
            allowClear
            placeholder={t("Select Role")}
          />
        </Form.Item>
        <Form.Item
          label='Team'
          name='teamEdit'
          rules={[
            {
              required: true,
            },
          ]}
          initialValue={usersData?.team?.id}
        >
          <Select
            {...teamSelectProps}
            allowClear
            placeholder={t("Select Team")}
          />
        </Form.Item>
        <Form.Item label='Password' name={["password"]}>
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
